/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetChartersQueryVariables = Types.Exact<{
  search: Types.CharterSearch;
  pagination: Types.Pagination;
}>;


export type GetChartersQuery = {
  __typename?: 'Query',
  charters: {
    __typename?: 'CharterPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'PurchaseCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      createdOn: number,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    } | {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      createdOn: number,
      broker?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    }> | null
  }
};

export type GetSalesChartersQueryVariables = Types.Exact<{
  search: Types.CharterSearch;
  pagination: Types.Pagination;
}>;


export type GetSalesChartersQuery = {
  __typename?: 'Query',
  salesCharters: {
    __typename?: 'SalesCharterPage',
    totalElements: number,
    content?: Array<{
      __typename: 'SalesCharter',
      id: number,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      charterNumber: string,
      firstLoadingDate?: number | null,
      createdOn: number,
      shortNotice: boolean,
      blDate?: number | null,
      customerReference?: string | null,
      dossierNumber?: string | null,
      totalRevenue: number,
      openDeclarationCount: number,
      openInvoiceCount: number,
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      broker?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      cargos: Array<{
        __typename?: 'Cargo',
        id: number,
        productDetails?: string | null,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null,
        firstLoadingAction?: {
          __typename?: 'CargoAction',
          start?: number | null,
          end?: number | null,
          displayAsWindow?: boolean | null
        } | null
      }>,
      voyages?: Array<{
        __typename?: 'Voyage',
        id: number,
        voyageNumber: string,
        inactivityType?: Types.InactivityType | null,
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string
        },
        lastStatusChange?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            closedStatus: boolean,
            finishedStatus: boolean
          }
        } | null
      }> | null,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      },
      contacts?: Array<{
        __typename?: 'SalesCharterContact',
        contactRoleType: Types.ContactRoleType,
        contact: {
          __typename?: 'Contact',
          id: number,
          name?: string | null,
          email?: string | null
        }
      }> | null
    }> | null
  }
};

export type GetDefaultOrderEntryContactsForSalesCharterQueryVariables = Types.Exact<{
  search: Types.ContactSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetDefaultOrderEntryContactsForSalesCharterQuery = {
  __typename?: 'Query',
  contacts: {
    __typename?: 'ContactPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'Contact',
      id: number,
      name?: string | null,
      email?: string | null,
      contactRoleTypes?: Array<Types.ContactRoleType> | null
    }> | null
  }
};

export type SalesCharterSuggestedContractsQueryVariables = Types.Exact<{
  charterId: Types.Scalars['Long']['input'];
  pagination: Types.Pagination;
}>;


export type SalesCharterSuggestedContractsQuery = {
  __typename?: 'Query',
  suggestedContracts?: {
    __typename?: 'ContractPage',
    content?: Array<{
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      description?: string | null,
      validFrom?: number | null,
      validUntil?: number | null,
      charterType: Types.CharterType,
      charterSubtype: Types.CharterSubtype,
      charters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number
      } | {
        __typename?: 'SalesCharter',
        id: number
      }> | null
    }> | null
  } | null
};

export type NextShipNominationStatusesQueryVariables = Types.Exact<{
  currentStatus?: Types.InputMaybe<Types.ShipNominationStatus>;
}>;


export type NextShipNominationStatusesQuery = {
  __typename?: 'Query',
  nextShipNominationStatuses: Array<{
    __typename?: 'ShipNominationStatusType',
    name: Types.ShipNominationStatus,
    color: string,
    languageKeyPrefix: string
  }>
};

export type NextSalesCharterStatusesQueryVariables = Types.Exact<{
  currentStatus?: Types.InputMaybe<Types.SalesCharterStatus>;
}>;


export type NextSalesCharterStatusesQuery = {
  __typename?: 'Query',
  nextSalesCharterStatuses: Array<{
    __typename?: 'SalesCharterStatusType',
    name: Types.SalesCharterStatus,
    color: string,
    languageKeyPrefix: string
  }>
};

export type SalesCharterStatusChangesQueryVariables = Types.Exact<{
  salesCharterId: Types.Scalars['Long']['input'];
}>;


export type SalesCharterStatusChangesQuery = {
  __typename?: 'Query',
  salesCharterStatusChanges: Array<{
    __typename?: 'SalesCharterStatusChange',
    id: number,
    createdOn: number,
    notes?: string | null,
    status: {
      __typename?: 'SalesCharterStatusType',
      name: Types.SalesCharterStatus,
      color: string,
      languageKeyPrefix: string
    },
    appliedBy: {
      __typename?: 'AccountDetails',
      id: number,
      username?: string | null,
      displayName?: string | null
    }
  }>
};

export type ShipNominationStatusChangesQueryVariables = Types.Exact<{
  salesCharterId: Types.Scalars['Long']['input'];
}>;


export type ShipNominationStatusChangesQuery = {
  __typename?: 'Query',
  shipNominationStatusChanges: Array<{
    __typename?: 'ShipNominationStatusChange',
    id: number,
    notes?: string | null,
    createdOn: number,
    ship: {
      __typename?: 'Ship',
      id: number,
      name: string
    },
    status: {
      __typename?: 'ShipNominationStatusType',
      name: Types.ShipNominationStatus,
      color: string,
      languageKeyPrefix: string
    },
    appliedBy: {
      __typename?: 'AccountDetails',
      id: number,
      username?: string | null,
      displayName?: string | null
    }
  }>
};

export type GetPurchaseCharterQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetPurchaseCharterQuery = {
  __typename?: 'Query',
  purchaseCharter: {
    __typename?: 'PurchaseCharter',
    id: number,
    charterNumber: string,
    type: Types.CharterType,
    subtype: Types.CharterSubtype,
    relationType?: Types.RelationType | null,
    customerReference?: string | null,
    validFrom?: number | null,
    validUntil?: number | null,
    ships?: Array<{
      __typename?: 'Ship',
      id: number,
      name: string,
      bargeType?: Types.BargeType | null
    }> | null,
    creditor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    debtor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    contract?: {
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      versionNumber?: string | null,
      charterType: Types.CharterType,
      charterSubtype: Types.CharterSubtype,
      isEditable: boolean,
      description?: string | null,
      memo?: string | null,
      noticePeriod?: Types.NoticePeriod | null,
      validFrom?: number | null,
      validUntil?: number | null,
      statusUpdatedOn?: number | null,
      allIn?: boolean | null,
      includePricingInNomination: boolean,
      isParentContract?: boolean | null,
      agreementsHaveChanged?: boolean | null,
      status: {
        __typename?: 'ContractStatusType',
        name: Types.ContractStatus,
        color: string,
        languageKeyPrefix: string
      },
      labels?: Array<{
        __typename?: 'Label',
        id: number,
        text: string,
        type: Types.LabelType,
        color: string
      }> | null,
      agreements: Array<{
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        ships?: Array<{
          __typename?: 'Ship',
          id: number,
          name: string,
          owner?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null
        }> | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      }>,
      currency?: {
        __typename?: 'Currency',
        isoCode?: string | null,
        rate?: number | null,
        symbol?: string | null
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        applicationRelation?: boolean | null,
        customer?: boolean | null,
        operator?: boolean | null,
        shipManger?: boolean | null,
        isShipManager?: boolean | null,
        supplier?: boolean | null,
        address?: {
          __typename?: 'Address',
          street?: string | null,
          zipCode?: string | null,
          town?: string | null,
          country?: string | null
        } | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          type?: string | null,
          name?: string | null,
          insertion?: string | null,
          surName?: string | null,
          email?: string | null
        }>
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        applicationRelation?: boolean | null,
        customer?: boolean | null,
        operator?: boolean | null,
        shipManger?: boolean | null,
        isShipManager?: boolean | null,
        supplier?: boolean | null,
        address?: {
          __typename?: 'Address',
          street?: string | null,
          zipCode?: string | null,
          town?: string | null,
          country?: string | null
        } | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          type?: string | null,
          name?: string | null,
          insertion?: string | null,
          surName?: string | null,
          email?: string | null
        }>
      } | null,
      creditorContact?: {
        __typename?: 'Contact',
        id: number,
        name?: string | null
      } | null,
      debtorContact?: {
        __typename?: 'Contact',
        id: number,
        name?: string | null
      } | null,
      documents?: Array<{
        __typename?: 'Document',
        id: number,
        description?: string | null,
        type: string,
        documentEntity: Types.DocumentEntity,
        filename?: string | null
      }> | null,
      comments: Array<{
        __typename?: 'Comment',
        id: number,
        comment: string,
        created: number,
        createdBy: {
          __typename?: 'AccountDetails',
          id: number,
          username?: string | null,
          displayName?: string | null
        },
        label?: {
          __typename?: 'Label',
          id: number,
          type: Types.LabelType,
          text: string,
          color: string
        } | null
      }>,
      charters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number
      } | {
        __typename?: 'SalesCharter',
        id: number
      }> | null,
      parentContract?: {
        __typename?: 'Contract',
        id: number,
        contractNumber?: string | null,
        agreements: Array<{
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          ships?: Array<{
            __typename?: 'Ship',
            id: number,
            name: string,
            owner?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null
          }> | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        }>
      } | null,
      termsAndConditions?: {
        __typename?: 'TermsAndConditions',
        id: number,
        description?: string | null
      } | null
    } | null,
    allContracts?: Array<{
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      versionNumber?: string | null,
      charterType: Types.CharterType,
      charterSubtype: Types.CharterSubtype,
      isEditable: boolean,
      description?: string | null,
      memo?: string | null,
      noticePeriod?: Types.NoticePeriod | null,
      validFrom?: number | null,
      validUntil?: number | null,
      statusUpdatedOn?: number | null,
      allIn?: boolean | null,
      includePricingInNomination: boolean,
      isParentContract?: boolean | null,
      agreementsHaveChanged?: boolean | null,
      status: {
        __typename?: 'ContractStatusType',
        name: Types.ContractStatus,
        color: string,
        languageKeyPrefix: string
      },
      labels?: Array<{
        __typename?: 'Label',
        id: number,
        text: string,
        type: Types.LabelType,
        color: string
      }> | null,
      agreements: Array<{
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        ships?: Array<{
          __typename?: 'Ship',
          id: number,
          name: string,
          owner?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null
        }> | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
          laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
          laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
          laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
          demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
          laytimeAllowed?: number | null,
          defaultCargoActionTypes?: Array<Types.CallType> | null,
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ManualCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TieredCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          id: number,
          type: Types.CalculationMethodType,
          description?: string | null,
          price?: number | null
        } | null
      }>,
      currency?: {
        __typename?: 'Currency',
        isoCode?: string | null,
        rate?: number | null,
        symbol?: string | null
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        applicationRelation?: boolean | null,
        customer?: boolean | null,
        operator?: boolean | null,
        shipManger?: boolean | null,
        isShipManager?: boolean | null,
        supplier?: boolean | null,
        address?: {
          __typename?: 'Address',
          street?: string | null,
          zipCode?: string | null,
          town?: string | null,
          country?: string | null
        } | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          type?: string | null,
          name?: string | null,
          insertion?: string | null,
          surName?: string | null,
          email?: string | null
        }>
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        email?: string | null,
        applicationRelation?: boolean | null,
        customer?: boolean | null,
        operator?: boolean | null,
        shipManger?: boolean | null,
        isShipManager?: boolean | null,
        supplier?: boolean | null,
        address?: {
          __typename?: 'Address',
          street?: string | null,
          zipCode?: string | null,
          town?: string | null,
          country?: string | null
        } | null,
        contacts: Array<{
          __typename?: 'Contact',
          id: number,
          type?: string | null,
          name?: string | null,
          insertion?: string | null,
          surName?: string | null,
          email?: string | null
        }>
      } | null,
      creditorContact?: {
        __typename?: 'Contact',
        id: number,
        name?: string | null
      } | null,
      debtorContact?: {
        __typename?: 'Contact',
        id: number,
        name?: string | null
      } | null,
      documents?: Array<{
        __typename?: 'Document',
        id: number,
        description?: string | null,
        type: string,
        documentEntity: Types.DocumentEntity,
        filename?: string | null
      }> | null,
      comments: Array<{
        __typename?: 'Comment',
        id: number,
        comment: string,
        created: number,
        createdBy: {
          __typename?: 'AccountDetails',
          id: number,
          username?: string | null,
          displayName?: string | null
        },
        label?: {
          __typename?: 'Label',
          id: number,
          type: Types.LabelType,
          text: string,
          color: string
        } | null
      }>,
      charters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number
      } | {
        __typename?: 'SalesCharter',
        id: number
      }> | null,
      parentContract?: {
        __typename?: 'Contract',
        id: number,
        contractNumber?: string | null,
        agreements: Array<{
          __typename?: 'AddressCommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'BlockFreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'BunkerAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'CleaningAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'CommissionAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DailyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DangerousGoodAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DeadfreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DemurrageAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'DemurrageCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'FeetAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'FreightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'GasolineAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'GasolinePriceAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'HoseRentalAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'HourlyAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'LumpsumAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'MultiCargoAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'MultiOrderAdjustmentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'NitrogenPurgingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'OogAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'PJKAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'PostCalculationAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ReeferAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'RentAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ReturnFreightDiscountAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'ShipAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          ships?: Array<{
            __typename?: 'Ship',
            id: number,
            name: string,
            owner?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null
          }> | null,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'SupplementaryHeatingAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'TeuAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'TextAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WaterLevelAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WaterwayAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WeightAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        } | {
          __typename?: 'WeightRangeAgreement',
          id: number,
          type: Types.AgreementTypeEnum,
          calculationMethod?: {
            __typename?: 'CargoQuantityCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'CoveredByFreightPriceCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationCalculationMethod',
            laytimeRoundingRule?: Types.DemurrageCalculationRoundingRule | null,
            laytimeRoundingUnit?: Types.DemurrageCalculationRoundingUnit | null,
            laytimeRoundingScope?: Types.DemurrageCalculationRoundingScope | null,
            laytimePeriodRegime?: Types.DemurrageCalculationPeriodRegime | null,
            demurrageCalculationUnit?: Types.DemurrageCalculationUnit | null,
            laytimeAllowed?: number | null,
            defaultCargoActionTypes?: Array<Types.CallType> | null,
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'DemurrageCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'GasoilConsumptionCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'LumpsumCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ManualCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'PercentageOnAgreementsCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'QuantityUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'ReferenceRateCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'StaffelCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TieredCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | {
            __typename?: 'TimeUnitCalculationMethod',
            id: number,
            type: Types.CalculationMethodType,
            description?: string | null,
            price?: number | null
          } | null
        }>
      } | null,
      termsAndConditions?: {
        __typename?: 'TermsAndConditions',
        id: number,
        description?: string | null
      } | null
    }> | null,
    voyages?: Array<{
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      externalVoyageNumber?: string | null,
      isThirdParty: boolean,
      start?: number | null,
      end?: number | null,
      invoiceableWeek?: number | null,
      created?: number | null,
      isBallast: boolean,
      actualWeightFilledIn: boolean,
      actualTimeFilledIn: boolean,
      actualStart?: number | null,
      actualEnd?: number | null,
      ship: {
        __typename?: 'Ship',
        id: number,
        bargeType?: Types.BargeType | null,
        name: string,
        operator?: {
          __typename?: 'Relation',
          id: number,
          name: string,
          isApplicationRelation?: boolean | null
        } | null,
        fleets: Array<{
          __typename?: 'Fleet',
          id: number,
          description: string
        }>
      },
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      purchaseCharters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        customerReference?: string | null,
        charterNumber: string,
        creditor: {
          __typename?: 'Relation',
          id: number,
          name: string,
          customerNumber?: string | null
        }
      }> | null,
      from?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      to?: {
        __typename?: 'Location',
        id: number,
        description: string,
        locationGroups: Array<{
          __typename?: 'Location',
          type: Types.LocationType,
          description: string
        }>
      } | null,
      calls: Array<{
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        ptd?: number | null,
        eta?: number | null,
        systemEta?: number | null,
        etd?: number | null,
        ata?: number | null,
        systemAta?: number | null,
        atd?: number | null,
        systemAtd?: number | null,
        actualStatusCode?: number | null,
        simulatedTimestamp: boolean,
        location: {
          __typename?: 'Location',
          id: number,
          code?: string | null,
          type: Types.LocationType,
          displayCode?: string | null,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            type: Types.LocationType,
            description: string
          }>
        },
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        linkedChildCalls: Array<{
          __typename?: 'Call',
          id: number,
          weight?: number | null,
          voyage: {
            __typename?: 'Voyage',
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        }>,
        voyage: {
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            bargeType?: Types.BargeType | null
          }
        },
        cargos: Array<{
          __typename?: 'CargoAction',
          id: number
        }>
      }>,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      scopeIn?: {
        __typename?: 'Scope',
        desired?: number | null,
        planned?: number | null,
        expected?: number | null,
        systemExpected?: number | null,
        actual?: number | null,
        systemActual?: number | null,
        expectedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        plannedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        actualLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null,
      scopeOut?: {
        __typename?: 'Scope',
        desired?: number | null,
        planned?: number | null,
        expected?: number | null,
        systemExpected?: number | null,
        actual?: number | null,
        systemActual?: number | null,
        expectedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        plannedLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null,
        actualLocation?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      } | null,
      cargoCharters?: Array<{
        __typename?: 'SalesCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        debtor: {
          __typename?: 'Relation',
          id: number,
          name: string
        }
      } | null> | null,
      sailingReport?: {
        __typename?: 'SailingReport',
        id: number
      } | null,
      cargos: Array<{
        __typename?: 'Cargo',
        id: number,
        productDetails?: string | null,
        cargoNumber?: string | null,
        loadingReference?: string | null,
        dischargingReference?: string | null,
        isWeightPrimary: boolean,
        isVolumePrimary: boolean,
        waterLevelOptimised: boolean,
        volume?: number | null,
        weight?: number | null,
        actions: Array<{
          __typename?: 'CargoAction',
          id: number
        }>,
        product?: {
          __typename?: 'Product',
          id: number,
          name: string
        } | null,
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }>
    }> | null
  }
};

export type DeclarationsQueryVariables = Types.Exact<{
  charterId: Types.Scalars['Long']['input'];
}>;


export type DeclarationsQuery = {
  __typename?: 'Query',
  declarations?: Array<{
    __typename?: 'PurchaseDeclaration',
    id: number,
    createdOn?: number | null,
    closedOn?: number | null,
    financiallyReadiedOn?: number | null,
    totalPriceExcVAT?: number | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    createdBy?: {
      __typename?: 'AccountDetails',
      id: number,
      username?: string | null,
      displayName?: string | null
    } | null,
    invoiceGroupType?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null,
    invoiceLines: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      approved?: boolean | null,
      summary?: string | null,
      calculationSummary?: string | null,
      quantity?: number | null,
      totalPriceExcVAT?: number | null,
      totalPriceIncVAT?: number | null,
      unit?: string | null,
      unexpected?: boolean | null,
      invoiceReference?: string | null,
      description?: string | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      costType?: {
        __typename?: 'CostType',
        id: number,
        title_de?: string | null,
        title_en?: string | null,
        title_nl?: string | null
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      price?: {
        __typename?: 'Price',
        value?: number | null,
        currency?: {
          __typename?: 'Currency',
          isoCode?: string | null,
          rate?: number | null,
          symbol?: string | null
        } | null
      } | null,
      linkedDeclarationValue?: {
        __typename?: 'DeclarationValue',
        price?: number | null,
        quantity?: number | null
      } | null,
      agreement?: {
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | null
    }>
  } | {
    __typename?: 'SalesDeclaration',
    id: number,
    createdOn?: number | null,
    closedOn?: number | null,
    financiallyReadiedOn?: number | null,
    totalPriceExcVAT?: number | null,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    createdBy?: {
      __typename?: 'AccountDetails',
      id: number,
      username?: string | null,
      displayName?: string | null
    } | null,
    invoiceGroupType?: {
      __typename?: 'InvoiceGroupType',
      id: number,
      name: string
    } | null,
    invoiceLines: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      approved?: boolean | null,
      summary?: string | null,
      calculationSummary?: string | null,
      quantity?: number | null,
      totalPriceExcVAT?: number | null,
      totalPriceIncVAT?: number | null,
      unit?: string | null,
      unexpected?: boolean | null,
      invoiceReference?: string | null,
      description?: string | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      costType?: {
        __typename?: 'CostType',
        id: number,
        title_de?: string | null,
        title_en?: string | null,
        title_nl?: string | null
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      price?: {
        __typename?: 'Price',
        value?: number | null,
        currency?: {
          __typename?: 'Currency',
          isoCode?: string | null,
          rate?: number | null,
          symbol?: string | null
        } | null
      } | null,
      linkedDeclarationValue?: {
        __typename?: 'DeclarationValue',
        price?: number | null,
        quantity?: number | null
      } | null,
      agreement?: {
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | null
    }>
  }> | null
};

export type GetChartersForSelectQueryVariables = Types.Exact<{
  search: Types.CharterSearch;
}>;


export type GetChartersForSelectQuery = {
  __typename?: 'Query',
  charters: {
    __typename?: 'CharterPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'PurchaseCharter',
      validFrom?: number | null,
      validUntil?: number | null,
      id: number,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      charterNumber: string,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    } | {
      __typename?: 'SalesCharter',
      id: number,
      type: Types.CharterType,
      subtype: Types.CharterSubtype,
      charterNumber: string,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    }> | null
  }
};

export type GetSpotSalesChartersQueryVariables = Types.Exact<{
  search: Types.CharterSearch;
  pagination: Types.Pagination;
}>;


export type GetSpotSalesChartersQuery = {
  __typename?: 'Query',
  salesCharters: {
    __typename?: 'SalesCharterPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'SalesCharter',
      customerReference?: string | null,
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      createdOn: number,
      cargos: Array<{
        __typename?: 'Cargo',
        id: number
      }>,
      creditor: {
        __typename?: 'Relation',
        id: number,
        name: string
      },
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    }> | null
  }
};

export type GetSpotSalesCharterQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetSpotSalesCharterQuery = {
  __typename?: 'Query',
  salesCharter: {
    __typename?: 'SalesCharter',
    id: number,
    charterNumber: string,
    creditor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    debtor: {
      __typename?: 'Relation',
      id: number,
      name: string
    }
  }
};

export type GetCharterForSideviewerQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetCharterForSideviewerQuery = {
  __typename?: 'Query',
  charter: {
    __typename: 'PurchaseCharter',
    id: number,
    charterNumber: string,
    type: Types.CharterType,
    subtype: Types.CharterSubtype,
    relationType?: Types.RelationType | null,
    customerReference?: string | null,
    createdOn: number,
    voyages?: Array<{
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      inactivityType?: Types.InactivityType | null,
      start?: number | null,
      end?: number | null,
      ship: {
        __typename?: 'Ship',
        id: number,
        name: string,
        bargeType?: Types.BargeType | null
      },
      calls: Array<{
        __typename?: 'Call',
        id: number
      }>,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          closedStatus: boolean,
          finishedStatus: boolean
        }
      } | null
    }> | null,
    creditor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    debtor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    contract?: {
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      charterType: Types.CharterType,
      isEditable: boolean,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    } | null
  } | {
    __typename: 'SalesCharter',
    id: number,
    charterNumber: string,
    type: Types.CharterType,
    subtype: Types.CharterSubtype,
    relationType?: Types.RelationType | null,
    customerReference?: string | null,
    createdOn: number,
    status: {
      __typename?: 'SalesCharterStatusType',
      name: Types.SalesCharterStatus,
      color: string,
      languageKeyPrefix: string
    },
    broker?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    voyages?: Array<{
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      inactivityType?: Types.InactivityType | null,
      start?: number | null,
      end?: number | null,
      ship: {
        __typename?: 'Ship',
        id: number,
        name: string,
        bargeType?: Types.BargeType | null
      },
      calls: Array<{
        __typename?: 'Call',
        id: number
      }>,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          closedStatus: boolean,
          finishedStatus: boolean
        }
      } | null
    }> | null,
    creditor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    debtor: {
      __typename?: 'Relation',
      id: number,
      name: string
    },
    contract?: {
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      charterType: Types.CharterType,
      isEditable: boolean,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    } | null
  }
};


export const GetChartersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]}}]} as unknown as DocumentNode<GetChartersQuery, GetChartersQueryVariables>;
export const GetSalesChartersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSalesCharters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesCharters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesCharterStatusChangeSalesCharter"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingDate"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shortNotice"}},{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"dossierNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"openDeclarationCount"}},{"kind":"Field","name":{"kind":"Name","value":"openInvoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesCharterStatusChangeSalesCharter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailWillBeSentToContactsAlertSalesCharterContact"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailWillBeSentToContactsAlertSalesCharterContact"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharterContact"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactRoleType"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetSalesChartersQuery, GetSalesChartersQueryVariables>;
export const GetDefaultOrderEntryContactsForSalesCharterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultOrderEntryContactsForSalesCharter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"contactRoleTypes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]} as unknown as DocumentNode<GetDefaultOrderEntryContactsForSalesCharterQuery, GetDefaultOrderEntryContactsForSalesCharterQueryVariables>;
export const SalesCharterSuggestedContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesCharterSuggestedContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestedContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"charterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"charterType"}},{"kind":"Field","name":{"kind":"Name","value":"charterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"charters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SalesCharterSuggestedContractsQuery, SalesCharterSuggestedContractsQueryVariables>;
export const NextShipNominationStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nextShipNominationStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShipNominationStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextShipNominationStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}}]} as unknown as DocumentNode<NextShipNominationStatusesQuery, NextShipNominationStatusesQueryVariables>;
export const NextSalesCharterStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nextSalesCharterStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharterStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextSalesCharterStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}}]} as unknown as DocumentNode<NextSalesCharterStatusesQuery, NextSalesCharterStatusesQueryVariables>;
export const SalesCharterStatusChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesCharterStatusChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesCharterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesCharterStatusChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"salesCharterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesCharterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<SalesCharterStatusChangesQuery, SalesCharterStatusChangesQueryVariables>;
export const ShipNominationStatusChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"shipNominationStatusChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"salesCharterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipNominationStatusChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"salesCharterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"salesCharterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<ShipNominationStatusChangesQuery, ShipNominationStatusChangesQueryVariables>;
export const GetPurchaseCharterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPurchaseCharter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseCharterVoyages"}},{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"charterContract"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allContracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"charterContract"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PurchaseCharterVoyages"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"NullValue"}},{"kind":"Argument","name":{"kind":"Name","value":"excludeEmpty"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"externalVoyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isThirdParty"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"operator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fleets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customerNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceableWeek"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"scopeOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"desired"}},{"kind":"Field","name":{"kind":"Name","value":"planned"}},{"kind":"Field","name":{"kind":"Name","value":"expected"}},{"kind":"Field","name":{"kind":"Name","value":"systemExpected"}},{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"systemActual"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}},{"kind":"Field","name":{"kind":"Name","value":"actualWeightFilledIn"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeFilledIn"}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actualStart"}},{"kind":"Field","name":{"kind":"Name","value":"actualEnd"}},{"kind":"Field","name":{"kind":"Name","value":"sailingReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"isWeightPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isVolumePrimary"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"charterContract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charterType"}},{"kind":"Field","name":{"kind":"Name","value":"charterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"noticePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"statusUpdatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"allIn"}},{"kind":"Field","name":{"kind":"Name","value":"includePricingInNomination"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"agreement"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"shipManger"}},{"kind":"Field","name":{"kind":"Name","value":"isShipManager"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"insertion"}},{"kind":"Field","name":{"kind":"Name","value":"surName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"shipManger"}},{"kind":"Field","name":{"kind":"Name","value":"isShipManager"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"insertion"}},{"kind":"Field","name":{"kind":"Name","value":"surName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtorContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isParentContract"}},{"kind":"Field","name":{"kind":"Name","value":"parentContract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"parentContract"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreementsHaveChanged"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"agreement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShipAgreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DemurrageCalculationCalculationMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"laytimeRoundingRule"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeRoundingUnit"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeRoundingScope"}},{"kind":"Field","name":{"kind":"Name","value":"laytimePeriodRegime"}},{"kind":"Field","name":{"kind":"Name","value":"demurrageCalculationUnit"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCargoActionTypes"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"parentContract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"agreement"}}]}}]}}]} as unknown as DocumentNode<GetPurchaseCharterQuery, GetPurchaseCharterQueryVariables>;
export const DeclarationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Declarations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"declarations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"charterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"financiallyReadiedOn"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"calculationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceIncVAT"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unexpected"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReference"}},{"kind":"Field","name":{"kind":"Name","value":"linkedDeclarationValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<DeclarationsQuery, DeclarationsQueryVariables>;
export const GetChartersForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChartersForSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"NullValue"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetChartersForSelectQuery, GetChartersForSelectQueryVariables>;
export const GetSpotSalesChartersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpotSalesCharters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CharterSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesCharters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]}}]} as unknown as DocumentNode<GetSpotSalesChartersQuery, GetSpotSalesChartersQueryVariables>;
export const GetSpotSalesCharterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpotSalesCharter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesCharter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetSpotSalesCharterQuery, GetSpotSalesCharterQueryVariables>;
export const GetCharterForSideviewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCharterForSideviewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharterSideViewerVoyage"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"excludeEmpty"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CharterSideViewerVoyage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charterType"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CharterSideViewerVoyage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Voyage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}}]}}]}}]}}]} as unknown as DocumentNode<GetCharterForSideviewerQuery, GetCharterForSideviewerQueryVariables>;